import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CdpEwSelectionCard from "./component";
import { setSelectedEwPlan, updateExtendedWarrantySelection } from "../car-details/actions";

const mapStateToProps = ({
    carDetails: {
        isExtendedWarrantySelected = false
    },
    carDetails: {
        content
    },
    checkout: {
        order
    }
}) => {
    return {
        isExtendedWarrantySelected,
        content,
        order
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateExtendedWarrantySelectionConnect: updateExtendedWarrantySelection,
    setSelectedEwPlanConnect: setSelectedEwPlan
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CdpEwSelectionCard);
